/**
 * @fileoverview GET handler for the "/integrations/direct/cdi/import-keys/:app_group_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { integrationsDirectCdiImportKeysAppGroupId } from "./constants";
import type { IntegrationsDirectCdiImportKeysAppGroupIdResult } from "./types";

export const getIntegrationsDirectCdiImportKeysAppGroupId = reactQueryFetcherAdapter(
  integrationsDirectCdiImportKeysAppGroupId,
  (signal: AbortSignal, appGroupId: string): Promise<IntegrationsDirectCdiImportKeysAppGroupIdResult> => {
    return fetch(`/integrations/direct/cdi/import-keys/${appGroupId}`, "GET", {}, { signal });
  }
);
